
import { supabase } from '@/lib/supabase'

export const signInWithGoogle = async () => {
  console.log('Tentative de connexion avec Google...')
  try {
    // URL de redirection configurée dans Supabase
    const redirectUrl = 'https://api.scaloo.ai/auth/v1/callback'
    console.log('URL de redirection pour Google:', redirectUrl)
    
    // Générer un état aléatoire pour la sécurité OAuth
    const oauthState = Math.random().toString(36).substring(2, 15)
    
    // Stocker l'état pour la vérification ultérieure
    localStorage.setItem('oauthState', oauthState)
    
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: redirectUrl,
        scopes: 'email profile',
        queryParams: {
          // Adding access_type=offline to get refresh token
          access_type: 'offline',
          // Adding prompt=consent to ensure we always get a refresh token
          prompt: 'consent',
          // Adding state parameter for security
          state: oauthState
        }
      }
    })
    
    if (error) {
      console.error('Erreur lors de la connexion avec Google:', error)
      throw error
    }
    
    console.log('Réponse de connexion Google:', data)
    return { data, error: null }
  } catch (error) {
    console.error('Exception lors de la connexion avec Google:', error)
    return { data: null, error }
  }
}
